module.exports = __webpack_public_path__ + "img/52.98361b7d.jpg";